<template>
  <div class="related-posts__container">
    <z-title
      align="left"
      class="related-posts__title"
      color="major"
      size="small"
      tag="h2"
      weight="medium"
    >
      {{ title }}
    </z-title>

    <z-button
      v-if="category"
      variant="secondary"
      tag="a"
      :href="`https://querobolsa.com.br/revista/assunto/${category}`"
      target="_blank"
      class="related-posts__cta"
    >
      Ver mais artigos
      <ZIcon
        :icon="['far', 'arrow-up-right-from-square']"
        class="related-posts__cta__icon"
      />
    </z-button>

    <div class="related-posts__grid">
      <a
        v-for="post in posts"
        :key="post.id"
        :aria-label="`${post.title} - leia mais`"
        :href="post.url"
        loading="lazy"
      >
        <article class="related-posts__article">
          <img
            :alt="post.title"
            :src="post.card_image_url"
            class="related-posts__article-img"
            loading="lazy"
          >

          <z-badge-text
            :aria-label="post.category"
            :value="post.category"
            :variant="badgeVariant"
            class="related-posts__article-badge"
          />

          <z-title
            align="left"
            color="interactive"
            size="extra-small"
            tag="h3"
            weight="medium"
            class="related-posts__article-title"
          >
            {{ post.title }}
          </z-title>

          <z-text
            align="left"
            color="minor"
            size="small"
            tag="p"
            class="related-posts__article-authority"
          >
            Por {{ post.author_name }} em {{ formatDate(post.published_at) }}
          </z-text>

          <z-text
            align="left"
            color="minor"
            size="small"
            tag="p"
            class="related-posts__article-description"
          >
            {{ post.meta_description }}
          </z-text>
        </article>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RelatedPosts',
  props: {
    posts: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    category: {
      type: String,
      required: false,
      default: '',
    },
    badgeVariant: {
      type: String,
      required: false,
      default: 'success',
    },
  },
  methods: {
    formatDate (date) {
      return new Date(date).toLocaleDateString('pt-BR', {
        timeZone: 'America/Sao_Paulo',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.related-posts__container {
  align-items: center;
  display: grid;
  gap: var(--unit-0600);
  grid-template-areas: (
    'A'
    'C'
    'B'
  );
  grid-template-columns: repeat(1, 1fr);

  @media (min-width: $breakpoint-tablet) {
    grid-template-areas: (
      'A . B'
      'C C C'
      );
    grid-template-columns: 1fr auto auto;
  }
}

.related-posts__title {
  grid-area: A;
  margin: 0;
}

.related-posts__cta {
  background-color: var(--color-blue-000);
  border-radius: var(--unit-0200);
  border: none;
  grid-area: B;
  margin: 0;

  &:active,
  &:hover {
    background-color: var(--color-blue-100);
  }
}

.related-posts__cta__icon {
  margin-left: var(--unit-0100);
}

.related-posts__grid {
  display: grid;
  gap: var(--unit-0500);
  grid-area: C;
  grid-template-columns: repeat(1, 1fr);
  margin: 0;

  @media (min-width: $breakpoint-tablet) {
    grid-column: span 3 / span 3;
    grid-template-columns: repeat(3, 1fr);
  }
}

.related-posts__article {
  align-content: flex-start;
  align-items: center;
  display: grid;
  gap: var(--unit-0200);
  height: 100%;
  justify-items: start;
  justify-content: start;
  padding: var(--unit-0300) 0;
  width: 100%;
}

.related-posts__article-img {
  border-radius: var(--unit-0300);
  height: 12rem;
  margin-bottom: var(--unit-0200);
  object-fit: cover;
  width: 100%;
}

.related-posts__article-title {
  line-clamp: 3;
  margin: var(--unit-0200) 0;
}

.related-posts__article-authority {
  margin: 0;
}

.related-posts__article-description {
  display: -webkit-box;
  margin: 0;
  line-clamp: 3;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
</style>
